import {
    FETCH_NUMBER_OF_ACTIVE_PLAYERS,
    FETCH_NUMBER_OF_ACTIVE_PLAYERS_FAIL,
    FETCH_NUMBER_OF_ACTIVE_PLAYERS_SUCCESS,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_FAIL,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_SUCCESS,
    FETCH_NUMBER_OF_PLAYERS,
    FETCH_NUMBER_OF_PLAYERS_FAIL,
    FETCH_NUMBER_OF_PLAYERS_SUCCESS,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_FAIL,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_SUCCESS,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_FAIL,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_SUCCESS,
    FETCH_OVERALL_SYSTEM_RISK,
    FETCH_OVERALL_SYSTEM_RISK_FAIL,
    FETCH_OVERALL_SYSTEM_RISK_SUCCESS,
    FETCH_REGISTRATIONS_PER_MONTH,
    FETCH_REGISTRATIONS_PER_MONTH_FAIL,
    FETCH_REGISTRATIONS_PER_MONTH_SUCCESS,
    FETCH_STATS,
    FETCH_TOP_RISKY_PLAYERS,
    FETCH_TOP_RISKY_PLAYERS_FAIL,
    FETCH_TOP_RISKY_PLAYERS_SUCCESS,
    FETCH_WORLDMAP,
    FETCH_WORLDMAP_FAIL,
    FETCH_WORLDMAP_SUCCESS
} from './actionTypes';
import * as _ from 'lodash';
import { allJurisdictionsCode } from '../../../../shared/models/jurisdictions';

const initialState = {
    worldmap: {
        data: {},
        loading: true,
        loaded: false,
        error: null
    },
    numberOfPlayers: {
        data: {
            number: 0,
            numberLastWeek: 0,
            percentageDifference: 0
        },
        loading: false,
        loaded: false,
        error: null
    },
    numberOfPlayersWithOpenAlerts: {
        data: {
            number: 0,
            numberLastWeek: 0,
            percentageDifference: 0
        },
        loading: false,
        loaded: false,
        error: null
    },
    numberOfActivePlayers: {
        data: {
            number: 0,
            numberLastWeek: 0,
            percentageDifference: 0
        },
        loaded: false,
        loading: false,
        error: null
    },
    numberOfEventsForTheLastDay: {
        data: {
            numberOfDepositsForTheLastDay: {
                number: 0,
                numberLastWeek: 0,
                percentageDifference: 0
            },
            numberOfWithdrawalsForTheLastDay: {
                number: 0,
                numberLastWeek: 0,
                percentageDifference: 0
            },
            numberOfBetsForTheLastDay: {
                number: 0,
                numberLastWeek: 0,
                percentageDifference: 0
            }
        },
        loaded: false,
        loading: false,
        error: null
    },
    topRiskyPlayers: {
        data: [],
        loaded: false,
        loading: false,
        error: null
    },
    registrationsPerMonth: {
        data: [],
        loaded: false,
        loading: false,
        error: null
    },
    overallSystemRisk: {
        data: {},
        loaded: false,
        loading: false,
        error: null
    },
    openAlerts: {
        data: {},
        loaded: false,
        loading: false,
        error: null
    }
};

export function statsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_STATS: {
            return action.payload.clearOldStats ? initialState : state;
        }
        case FETCH_WORLDMAP /* worldmap */:
            return {
                ...state,
                worldmap: {
                    ...state.worldmap,
                    loading: true
                }
            };
        case FETCH_WORLDMAP_SUCCESS: {
            const mappedCountryStats = _.values(action.payload.countryStats);
            const countryStatsObj = {
                ...action.payload.countryStats,
                [allJurisdictionsCode]: {
                    alertsLastHour: _.sumBy(
                        mappedCountryStats,
                        stat => +stat.alertsLastHour
                    ),
                    trafficLastHour: _.sumBy(
                        mappedCountryStats,
                        stat => +stat.trafficLastHour
                    )
                }
            };
            return {
                ...state,
                worldmap: {
                    data: {
                        countryStats: countryStatsObj
                    },
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        }
        case FETCH_WORLDMAP_FAIL:
            return {
                ...state,
                worldmap: { ...initialState.worldmap, error: action.payload }
            };
        case FETCH_NUMBER_OF_PLAYERS /* numberOfPlayers */:
            return {
                ...state,
                numberOfPlayers: {
                    ...state.numberOfPlayers,
                    loading: true
                }
            };
        case FETCH_NUMBER_OF_PLAYERS_SUCCESS:
            return {
                ...state,
                numberOfPlayers: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_NUMBER_OF_PLAYERS_FAIL:
            return {
                ...state,
                numberOfPlayers: {
                    ...initialState.numberOfPlayers,
                    error: action.payload
                }
            };
        case FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS /* numberOfPlayersWithOpenAlerts */:
            return {
                ...state,
                numberOfPlayersWithOpenAlerts: {
                    ...state.numberOfPlayersWithOpenAlerts,
                    loading: true
                }
            };
        case FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_SUCCESS:
            return {
                ...state,
                numberOfPlayersWithOpenAlerts: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_FAIL:
            return {
                ...state,
                numberOfPlayersWithOpenAlerts: {
                    ...initialState.numberOfPlayersWithOpenAlerts,
                    error: action.payload
                }
            };
        case FETCH_NUMBER_OF_ACTIVE_PLAYERS /* numberOfActivePlayers */:
            return {
                ...state,
                numberOfActivePlayers: {
                    ...state.numberOfActivePlayers,
                    loading: true
                }
            };
        case FETCH_NUMBER_OF_ACTIVE_PLAYERS_SUCCESS:
            return {
                ...state,
                numberOfActivePlayers: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_NUMBER_OF_ACTIVE_PLAYERS_FAIL:
            return {
                ...state,
                numberOfActivePlayers: {
                    ...initialState.numberOfActivePlayers,
                    error: action.payload
                }
            };
        case FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY /* numberOfEventsForTheLastDay */:
            return {
                ...state,
                numberOfEventsForTheLastDay: {
                    ...state.numberOfEventsForTheLastDay,
                    loading: true
                }
            };
        case FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_SUCCESS:
            return {
                ...state,
                numberOfEventsForTheLastDay: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_FAIL:
            return {
                ...state,
                numberOfEventsForTheLastDay: {
                    ...initialState.numberOfEventsForTheLastDay,
                    error: action.payload
                }
            };
        case FETCH_TOP_RISKY_PLAYERS /* topRiskyPlayers */:
            return {
                ...state,
                topRiskyPlayers: {
                    ...state.topRiskyPlayers,
                    loading: true
                }
            };
        case FETCH_TOP_RISKY_PLAYERS_SUCCESS:
            return {
                ...state,
                topRiskyPlayers: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_TOP_RISKY_PLAYERS_FAIL:
            return {
                ...state,
                topRiskyPlayers: {
                    ...initialState.topRiskyPlayers,
                    error: action.payload
                }
            };
        case FETCH_REGISTRATIONS_PER_MONTH /* registrationsPerMonth */:
            return {
                ...state,
                registrationsPerMonth: {
                    ...state.registrationsPerMonth,
                    loading: true
                }
            };
        case FETCH_REGISTRATIONS_PER_MONTH_SUCCESS:
            return {
                ...state,
                registrationsPerMonth: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_REGISTRATIONS_PER_MONTH_FAIL:
            return {
                ...state,
                registrationsPerMonth: {
                    ...initialState.registrationsPerMonth,
                    error: action.payload
                }
            };
        case FETCH_OVERALL_SYSTEM_RISK /* overallSystemRisk */:
            return {
                ...state,
                overallSystemRisk: {
                    ...state.overallSystemRisk,
                    loading: true
                }
            };
        case FETCH_OVERALL_SYSTEM_RISK_SUCCESS:
            return {
                ...state,
                overallSystemRisk: {
                    data: action.payload,
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_OVERALL_SYSTEM_RISK_FAIL:
            return {
                ...state,
                overallSystemRisk: {
                    ...initialState.overallSystemRisk,
                    error: action.payload
                }
            };
        case FETCH_OPEN_ALERTS_PER_RULE_CATEGORY /* openAlertsPerRuleCategory */:
            return {
                ...state,
                openAlertsPerRuleCategory: state.openAlertsPerRuleCategory
            };
        case FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_SUCCESS:
            return {
                ...state,
                openAlerts: {
                    data:
                        // todo: Black magic. This is old technical debt that needs to be removed - tried to keep it contained here so rest of the platform
                        _.mapValues(
                            _.keyBy(
                                action.payload,

                                'ruleCategoryFriendlyType'
                            ),
                            openAlertGroup => openAlertGroup.openAlerts
                        ) || {},
                    loaded: true,
                    loading: false,
                    error: null
                }
            };
        case FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_FAIL:
            return {
                ...state,
                openAlerts: {
                    ...initialState.openAlerts,
                    error: action.payload
                }
            };

        default:
            return state;
    }
}
